<template>
  <v-authorization title="Create Your Free InVan Account">
    <v-card-text>
      <v-text-field v-if="state == 0" v-model="name" label="Name" />
      <v-text-field v-if="state == 0" v-model="phone_number" label="Phone number" v-bind:rules="phoneNumberRules" ref="phone_number" v-bind:return-masked-value="false" prefix="+998" v-mask="mask"/>
      <v-text-field v-if="state == 0" v-model="organization" label="Organization" v-bind:rules="organizationRules" ref="organization"/>
      <v-checkbox  label="I agree to InOne" color="#4BAF4F" v-model="agree"/>
      <router-link to="/signin" style="text-decoration: none">I have an account?</router-link>
    </v-card-text>
    <template #action>
      <v-btn v-bind:disabled="!agree" v-if="state == 0" text color="#4BAF4F" v-on:click="signup">Signup</v-btn>
    </template>
  </v-authorization>
</template>
<script>
export default {
  name: 'Signup',
  data: () => ({
    agree: false,
    mask: '(##) ### - ## - ##',
    phone_number: null,
    organization: null,
    name: null,
    state: 0,
    phoneNumberRules: [value => !!value || 'Required'],
    organizationRules: [value => !!value || 'Required']
  }),
  methods: {
    async signup(){
      if(this.phone_number.length == 18){
      const signup = await this.$communicator('signup', {
        params: {
          name: this.name,
          phone_number: this.$communicator.clear_phone_number(this.phone_number),
          organization: this.organization
        }
      })
      if(signup.status == 200){
        if(signup.data.statusCode == 419){
          if(signup.data.status == 'organization'){
            const organization = this.organization
            this.organizationRules.push(value => value !== organization || 'Has already exists')
            this.$refs['organization'].validate()
          }
          if(signup.data.status == 'phone_number'){
            const phone_number = this.phone_number
            this.phoneNumberRules.push(value => value !== phone_number || 'Has already exists')
            this.$refs['phone_number'].validate()
          }
        }
        if(signup.data.statusCode == 200){
          this.$router.push({path: '/signin', query: { 'phone_number': this.phone_number }})
        }
      }}
    }
  }
}
</script>